export enum ActionTypes {
  create = 'create',
  copy = 'copy',
  edit = 'edit',
  delete = 'delete',
  view = 'view',
  viewKpi = 'viewKpi',
}

export enum FieldTypes {
  text = 'text',
  number = 'number',
  multiselect = 'multiselect',
  date = 'date',
  time = 'time',
  select = 'select',
  tree = 'tree',
  boolean = 'boolean',
  json = 'json',
  search = 'search',
  slider = 'slider',
  object = 'object',
  prioritySingle = 'prioritySingle',
  autocomplete = 'autocomplete',
  fileInput = 'fileInput',
  dayWeights = 'dayWeights',
  timeWeights = 'timeWeights',
  customTimeWeights = 'customTimeWeights',
}

export enum IntroLessonStatus {
  booked = 'booked',
  deleted = 'deleted',
  prompt = 'prompt',
  canceled = 'canceled',
  dropped = 'dropped',
  present = 'present',
  distribution = 'distribution',
  lost = 'lost',
  failed = 'failed',
  progress = 'progress',
  passed = 'passed',
}

export enum VisitPromptStatus {
  ready = 'ready',
  acontact = 'a_contact',
  mcontact = 'm_contact',
  error = 'error',
  reschedule = 'reschedule',
  refused = 'refused',
  missed = 'missed',
  ocontact = 'o_contact',
  confirmed = 'confirmed',
  dropped = 'dropped',
  canceled = 'canceled',
  present = 'present',
  lost = 'lost',
}

export enum KindsLanguage {
  en = 'en',
  ru = 'ru',
  es = 'es',
}

export enum DateFnsLanguage {
  en = 'en-US',
  es = 'es',
  ru = 'ru',
}

export enum PermissionsType {
  methodistManagerCalendar = 'methodist_manager_calendar',
  methodistManagerCalendarEdit = 'methodist_manager_calendar_edit',
  methodistList = 'methodist_list',
  methodistEdit = 'methodist_edit',
  methodistSchedule = 'methodist_schedule',
  methodistActivityCreate = 'methodist_activity_create',
  methodistActivityEdit = 'methodist_activity_edit',
  methodistActivityApprove = 'methodist_activity_approve',
  methodistActivityDelete = 'methodist_activity_delete',
  slotScheduleList = 'slot_schedule_list',
  slotScheduleEdit = 'slot_schedule_edit',
  slotsView = 'slots_view',
  methodistKindList = 'methodist_kind_list',
  methodistKindEdit = 'methodist_kind_edit',
  operator = 'operator',
  methodist = 'methodist',
  methodistGroupList = 'methodist_group_list',
  methodistGroupEdit = 'methodist_group_edit',
  tagList = 'tag_list',
  tagEdit = 'tag_edit',
  permissionList = 'permission_list',
  permissionEdit = 'permission_edit',
  productList = 'product_list',
  productEdit = 'product_edit',
  gradationList = 'gradation_list',
  gradationEdit = 'gradation_edit',
  introLessonFormatList = 'intro_lesson_format_list',
  introLessonFormatEdit = 'intro_lesson_format_edit',
  proficiencyList = 'proficiency_list',
  proficiencyEdit = 'proficiency_edit',
  subjectList = 'subject_list',
  subjectEdit = 'subject_edit',
  visitPromptStrategyList = 'visit_prompt_strategy_list',
  visitPromptStrategyEdit = 'visit_prompt_strategy_edit',
  modeList = 'mode_list',
  modeEdit = 'mode_edit',
  methodistLogList = 'methodist_log_list',
  methodistLogEdit = 'methodist_log_edit',
  showcaseStkList = 'showcase_stk_list',
  showcaseStkEdit = 'showcase_stk_edit',
  reportTemplateList = 'report_template_list',
  reportTemplateEdit = 'report_template_edit',
  instructionList = 'instruction_list',
  instructionEdit = 'instruction_edit',
  forecastList = 'forecast_list',
  forecastEdit = 'forecast_edit',
  autopilotProgressList = 'autopilot_progress_list',
  actionLogList = 'action_log_list',
  selfbookingList = 'selfbooking_list',
  globalVariablesList = 'global_variables_list',
  globalVariablesEdit = 'global_variables_edit',
  operatorForecastList = 'operator_forecast_list',
  operatorForecastEdit = 'operator_forecast_edit',
  methodistKpi = 'methodist_kpi',
  recordLesson = 'record_lesson',
}

export enum ForecastWeightsEnum {
  dayWeightsGroup = 'dayWeightsGroup',
  timeWeightsGroup = 'timeWeightsGroup',
  customTimeWeightsGroup = 'customTimeWeightsGroup',
  dayWeights = 'dayWeights',
  timeWeights = 'timeWeights',
  customTimeWeights = 'customTimeWeights',
}

export enum LocalDateLan {
  'ru' = 'ru-RU',
  'en' = 'en-US',
  'uk' = 'uk-UK',
  'tr' = 'tr-TR',
  'de' = 'de-DE',
  'fr' = 'fr-FR',
  'es' = 'es-ES',
}
